// src/sot/primitives/ListRow.jsx
import React from "react";
import { ChevronRight } from "lucide-react";
import { type as T } from "@/sot/tokens/typography.js";

/**
 * ListRow — SSOT row
 * - Title: Body Large (16/24 • 400, +0.5)
 * - Support: Body Large (16/24 • 400, +0.5)
 * - Optional leading (string path or node), trailing slot, chevron, and divider
 * - 12px radius card shape
 */
export default function ListRow({
  title,
  support,
  leading,
  trailing,
  onClick,
  showChevron = false,
  divider = true,
  disabled = false,
  className = "",
  rounded = true,
}) {
      const labelMediumStyle = {
    fontSize: `${T.labelMedium.size}px`,
    lineHeight: `${T.labelMedium.line}px`,
    fontWeight: T.labelMedium.weight,
    letterSpacing: `${T.labelMedium.letter}px`,
    color: "var(--Schemes-On-Surface-Variant,#5B6B86)",
    textAlign: "left",
  };

  const bodyLargeStyle = {
    fontSize: `${T.bodyLarge.size}px`,
    lineHeight: `${T.bodyLarge.line}px`,
    fontWeight: T.bodyLarge.weight,
    letterSpacing: "0.5px",
    color: "var(--Schemes-On-Surface,#040812)",
    textAlign: "left",
  };

  const buttonClasses = [
    "w-full text-left bg-[var(--Schemes-Surface,#FFFFFF)]",
    rounded ? "rounded-xl" : "",
    "overflow-hidden",
    disabled
      ? "opacity-60 cursor-not-allowed"
      : "active:scale-[0.998] transition",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={buttonClasses}
    >
      <div className="flex items-center px-4 py-4">
        {/* leading */}
        {leading ? (
          typeof leading === "string" ? (
            <img
              src={leading}
              alt=""
              width={20}
              height={20}
              className="mr-3 shrink-0 select-none"
              draggable="false"
            />
          ) : (
            <div className="mr-3 shrink-0">{leading}</div>
          )
        ) : null}

        {/* text */}
        <div className="flex-1 min-w-0">
        {/* If there is support/value, treat title as label (overline). Otherwise keep title as bodyLarge. */}
          <div style={support ? labelMediumStyle : bodyLargeStyle}>{title}</div>

          {support ? (
            <div className="mt-0.5" style={bodyLargeStyle}>
              {support}
            </div>
          ) : null}
        </div>

        {/* trailing slot */}
        {trailing}

        {/* chevron */}
        {showChevron ? (
          <ChevronRight className="w-5 h-5 ml-2 opacity-60" />
        ) : null}
      </div>

      {/* divider (inset 16px) */}
      {divider ? (
        <div
          className="h-px"
          style={{
            marginLeft: 16,
            background: "var(--Schemes-Outline-Variant, #E6E7EB)",
          }}
        />
      ) : null}
    </button>
  );
}
